/**
 * Flag icon component using real SVG flags from country-flag-icons
 */
import { HR, GB, DE, ES, FR, IT } from "country-flag-icons/react/3x2";

interface FlagIconProps {
  code: string;
  className?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FLAG_MAP: Record<string, any> = {
  hr: HR,
  en: GB,
  gb: GB,
  de: DE,
  es: ES,
  fr: FR,
  it: IT,
};

export const FlagIcon = ({ code, className = "w-5 h-4" }: FlagIconProps) => {
  const FlagComponent = FLAG_MAP[code.toLowerCase()];

  if (!FlagComponent) {
    return (
      <svg viewBox="0 0 30 20" className={className}>
        <rect width="30" height="20" fill="#e5e7eb" />
        <text x="15" y="14" textAnchor="middle" fontSize="10" fill="#374151" fontWeight="bold">
          {code.toUpperCase()}
        </text>
      </svg>
    );
  }

  return <FlagComponent className={className} />;
};
